export default __webpack_public_path__ + "static/media/logo-icon.3746b703.svg";